import { useEffect, useState } from 'react'
import { IUSPBannerItem, USPBannerItem } from './usp-banner-item.tsx'

interface IUSPBanner {}

const USPBanner = ({}: IUSPBanner) => {
	const [animate, setAnimate] = useState(true)
	const bannerItems: IUSPBannerItem[] = [
		{
			index: 0,
			iconName: 'rocket',
			text: 'Bokning på 5minuter',
		},
		{ index: 1, iconName: 'shield', text: 'Försäkrad' },
		{
			index: 2,
			iconName: 'education',
			text: 'Utbildning ingår',
		},
	]

	useEffect(() => {
		const interval = setInterval(
			() => {
				setAnimate(false)

				setTimeout(() => {
					setAnimate(true)
				}, 50)
			},
			bannerItems.length * 3000 + 1000,
		)

		return () => clearInterval(interval)
	}, [bannerItems.length])

	return (
		<div className="header-top mb-0">
			<div className="container h-full">
				<div className="row header-top__wrapper h-full justify-center py-2">
					{bannerItems.map(item => (
						<USPBannerItem key={item.iconName} {...item} animate={animate} />
					))}
				</div>
			</div>
		</div>
	)
}

export { USPBanner }
